module.exports = __webpack_public_path__ + "static/media/twitter.2881f962.svg";